var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pixi-animated-sprite',{attrs:{"z-index":10,"x":0,"y":0,"sprite-name":"confetti","sprite-directory":"/images/game/animations/","num-frames":10},on:{"added":_vm.animateSprite}})}
var staticRenderFns = []

export { render, staticRenderFns }